var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v("Aktualizacja produktu - nowe zdjęcie")]),_c('div',{staticClass:"card-panel grey-text text-darken-1"},[_c('h4',[_vm._v(_vm._s(_vm.uploadDiff.item.title)+" (id: "+_vm._s(_vm.uploadDiff.item.id)+")")]),_c('img',{staticClass:"materialboxed responsive-img",attrs:{"src":_vm.imagePreviewUrl}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }